
import styled from "styled-components";

export const StyledInput = styled.input`
  width: 100%;
  height: 2.5rem;
  color: var(--color-grey50);
  background-color: var(--color-grey20);
  border-radius: var(--radius-1);
  border: 1px solid var(--color-grey20);
  padding: 0 1rem;
  font-size: var(--font-size-14);

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-sizing: border-box;

  &:focus {
    outline: 1px solid var(--color-grey100);
    background-color: var(--color-white);
    color: var(--color-grey100);
  }

  &:out-of-range {
    outline: 1px solid var(--color-negative);
    background-color: var(--color-white);
    color: var(--color-grey100);
  }

  @media (min-width: 370px) {
    max-width: 370px;
  }
`;

export const StyledLabel = styled.label`
  color: var(--color-grey50);
  background-color: var(--color-white);
  font-size: var(--font-size-14);
  color: var(--color-grey100);
`;

export const StyledInputDiv = styled.fieldset`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.2rem;
  position: relative;
`;
